import React, { useState, useEffect } from "react";
import UserPool from "../utils/userPool";
import { CognitoUser } from "amazon-cognito-identity-js";
import { trackEvent } from "../utils/analytics";
const API_BASE = process.env.REACT_APP_API_BASE;

export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [club, setClub] = useState("");
  const [team, setTeam] = useState("");
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [clubs, setClubs] = useState([]);
  const [teams, setTeams] = useState([]);

  useEffect(() => {
  fetch(`${API_BASE}/clubs`)
      .then(res => res.json())
      .then(setClubs)
      .catch(err => console.error("Failed to load clubs", err));
    }, []);

  useEffect(() => {
  if (club) {
    fetch(`${API_BASE}/teams?clubId=${club}`)
      .then(res => res.json())
      .then(setTeams)
      .catch(err => console.error("Failed to load teams", err));
    }
  }, [club]);

  const handleRegister = (e) => {
    e.preventDefault();
    setLoading(true);
    trackEvent("registration_started", { role: "player" });

    if (!agreed) {
      trackEvent("registration_failed", { reason: "terms_not_accepted" });
      alert("You must confirm you are 18+ and agree to the terms.");
      setLoading(false);
      return;
    }

    UserPool.signUp(email, password, [
      { Name: "email", Value: email },
      { Name: "given_name", Value: firstName },
      { Name: "family_name", Value: lastName },
      { Name: "custom:club", Value: club },
      { Name: "custom:team", Value: team }
    ], null, async (err, result) => {
      if (err) {
        console.error("❌ Registration error:", err.message || JSON.stringify(err));
        trackEvent("registration_failed", { reason: err.code || "cognito_signup_error" });
        alert("Registration failed: " + (err.message || "Unknown error"));
        setLoading(false);
        return;
      }

      console.log("✅ Registration success:", result);
      trackEvent("registration_submitted", { role: "player" });

      // Save all fields into localStorage for confirm page
      localStorage.setItem("beercard_registration_email", email);
      localStorage.setItem("beercard_registration_firstName", firstName);
      localStorage.setItem("beercard_registration_lastName", lastName);
      localStorage.setItem("beercard_registration_club", club);
      localStorage.setItem("beercard_registration_team", team);
      localStorage.setItem("beercard_registration_clubId", club); 
      localStorage.setItem("beercard_registration_teamId", team);
      localStorage.setItem("beercard_registration_role", "player");
      localStorage.setItem("beercard_registration_password", password);

      alert("Registration successful! Please verify your email.");
      window.location.href = "/confirm"; // Redirect to confirmation page
      setLoading(false);
    });
  };

  return (
    <div className="p-6 max-w-md mx-auto">
      <h1 className="text-2xl font-bold mb-6 text-center">Register</h1>
      <form onSubmit={handleRegister} className="flex flex-col gap-4 text-black bg-white p-4 rounded shadow">
        <input type="text" placeholder="First Name" className="p-2 border rounded" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
        <input type="text" placeholder="Last Name" className="p-2 border rounded" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
        <select
  className="p-2 border rounded"
  value={club}
  onChange={(e) => setClub(e.target.value)}
  required
>
  <option value="">Select Club</option>
  {clubs.map(c => (
    <option key={c.clubId} value={c.clubId}>{c.club}</option>
  ))}
</select>

<select
  className="p-2 border rounded"
  value={team}
  onChange={(e) => setTeam(e.target.value)}
  required
>
  <option value="">Select Team</option>
  {teams.map(t => (
    <option key={t.teamId} value={t.teamId}>{t.clubID} {t.teamId}</option>
  ))}
</select>
        <input type="email" placeholder="Email" className="p-2 border rounded" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <input type="password" placeholder="Password" className="p-2 border rounded" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <label className="text-sm flex items-start gap-2">
        <input
          type="checkbox"
          className="mt-1"
          checked={agreed}
          onChange={(e) => setAgreed(e.target.checked)}
          required
        />
        <span>
        I am 18+ and agree to the{" "}
        <a href="/terms" target="_blank" className="text-blue-600 underline">
        TeamKitty Terms of Use
        </a>.
        </span>
        </label>
        <button type="submit" disabled={loading} className="bg-blue-600 text-white py-2 rounded hover:bg-blue-700 disabled:bg-gray-400">
          {loading ? "Registering..." : "Register"}
        </button>
      </form>
      <div
  style={{
    marginTop: "40px",
    textAlign: "center",
    fontSize: "13px",
    color: "#9ca3af",
  }}
>
  <a href="/privacy" style={{ marginRight: "16px", color: "#9ca3af" }}>
    Privacy Policy
  </a>

  <a href="/terms" style={{ marginRight: "16px", color: "#9ca3af" }}>
    Terms
  </a>

  <a href="/cookies" style={{ color: "#9ca3af" }}>
    Cookies
  </a>
</div>
    </div>
  );
}
